import {
  Box,
  Button,
  IconButton,
  Link,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AppButton from "../../components/app-button/AppButton";
import AppDialogDelete from "../../components/app-dialog-delete/AppDialogDelete";
import AppTable from "../../components/app-table/AppTable";
import Iconify from "../../components/iconify/Iconify";
import {
  getItems,
  itemDelete,
  itemFavoriteAction,
  itemPublishAction
} from "../../reduxStore/slices/itemSlice";
import { useNotify } from "../../utils/snackbarUtils";

function ItemsList(props) {
  const tableHead = [
    { id: "name", label: "Item Name", align: "left" },
    { id: "categoryName", label: "Category Name", align: "left" },
    { id: "price", label: "Price", align: "center" },
    { id: "discountedPrice", label: "Discounted Price", align: "center" },
    { id: "favourite", label: "Favourite", align: "center" },
    { id: "publishStatus", label: "Publish Status", align: "center" },
    { id: "createdAt", label: "Created At", align: "left" },
    { id: "actions", label: "Actions", align: "center", width: "140px" },
  ];

  const { showSuccess, handleApiError, showError } = useNotify();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const { list, loading: isLoading } = useSelector((state) => state.item);

  const storeId = user?.storeId;
  const tableRows = list;

  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});

  const getAllItems = async () => {
    try {
      await dispatch(getItems({ storeId })).unwrap();
    } catch (err) {
      handleApiError(err);
    }
  };

  // Load items
  useEffect(() => {
    if (storeId) {
      getAllItems();
    }
  }, [storeId]);

  const handleAddItem = () => {
    navigate("/app/config/item/add");
  };

  const handleDeleteClose = () => {
    setIsDeleteDialogOpen(false);
  };

  const togglePublishStatus = async (event, row) => {
    const obj = {
      store_id: storeId,
      product_uid: row.product_uid,
      product_id: row.product_id,
      is_published: Number(event.target.value) === 1 ? 0 : 1,
    };
    try {
      const res = await dispatch(itemPublishAction(obj)).unwrap();
      showSuccess(res.message);
    } catch (err) {
      handleApiError(err);
    }
  };

  const toggleIsFavorite = async (event, row) => {
    const obj = {
      store_id: storeId,
      product_uid: row.product_uid,
      product_id: row.product_id,
      is_favorite: Number(event.target.value) === 1 ? 0 : 1,
    };
    try {
      const res = await dispatch(itemFavoriteAction(obj)).unwrap();
      showSuccess(res.message);
    } catch (err) {
      handleApiError(err);
    }
  };

  const handleDeleteConfirm = async () => {
    setIsDeleteDialogOpen(false);
    const obj = {
      store_id: storeId,
      product_uid: selectedRow.product_uid,
      product_id: selectedRow.product_id,
      record_status: "R",
    };
    try {
      const res = await dispatch(itemDelete(obj)).unwrap();
      showSuccess(res.message);
    } catch (err) {
      handleApiError(err);
    }
  };

  const editActionClick = (e, row) => {
    setSelectedRow(row);
    navigate(`/app/config/item/edit/${row.product_uid}`);
  };

  const deleteActionClick = async (event, row) => {
    setIsDeleteDialogOpen(true);
    setSelectedRow(row);
  };

  const viewActionClick = () => {};
  return (
    <Box
      sx={{
        margin: "25px 60px",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mb={3}
      >
        <Stack direction="row" alignItems="center" spacing={2}>
          <Tooltip title="Back to Configuration">
            <IconButton onClick={() => navigate("/app/config")}>
              <Iconify icon="eva:arrow-back-fill" width={24} height={24} />
            </IconButton>
          </Tooltip>

          <Typography variant="h5" gutterBottom>
            Items
          </Typography>
        </Stack>
        <Link style={{ textDecoration: "none" }}>
          {tableRows.length > 0 && !isLoading && (
            <AppButton
              onClick={handleAddItem}
              variant="contained"
              startIcon={<Iconify icon="eva:plus-fill" />}
            >
              New Item
            </AppButton>
          )}
        </Link>
      </Stack>
      <Box>
        <AppTable
          tableHead={tableHead}
          tableRows={tableRows}
          listType="itemTables"
          searchPlaceholder="Search By Item Name"
          editActionClick={editActionClick}
          viewActionClick={viewActionClick}
          deleteActionClick={deleteActionClick}
          searchField={"product_name"}
          handleAddAction={handleAddItem}
          toggleSwitchStatus={togglePublishStatus}
          toggleSwitchAny={toggleIsFavorite}
          emptyTitle="No Items available"
          emptyDesc="Add new item to get started."
          emptyButtonLabel="New Item"
          isLoading={isLoading}
        />
      </Box>

      {isDeleteDialogOpen && (
        <AppDialogDelete
          isOpen={isDeleteDialogOpen}
          id={"delete_user_dialog"}
          title={<>Delete Item</>}
          footer={
            <>
              <Button
                autoFocus
                onClick={handleDeleteConfirm}
                className="confirm-delete-btn"
              >
                Delete
              </Button>
              <Button
                onClick={handleDeleteClose}
                variant="outlined"
                className="cancel-delete-btn"
              >
                Cancel
              </Button>
            </>
          }
        >
          <Typography
            style={{
              fontSize: 14,
              color: "#000",
            }}
          >
            Are you sure want to delete item?
          </Typography>
        </AppDialogDelete>
      )}
    </Box>
  );
}

export default ItemsList;
